import { useEffect, useState } from "react";
import { useAppSelector } from "@/redux/store";
import deliveryInfoService from "@/services/deliveryInfoService";
import LocalStorageService from "@/services/StorageService";
import { DeliveryInfo } from "@/components/product/webSizes/types";
import { selectLoggedInStatus } from "@/util/selectors";
import { EXPRESS_DELIVERY_STATE_ID_KEY } from "@/constants";

const useDeliveryOptionsInfo = () => {
  const [deliveryInfo, setDeliveryInfo] = useState([]);
  const isUserLoggedIn = useAppSelector(selectLoggedInStatus);
  const loyaltyTier = useAppSelector(
    state => state.myAccountReducer.loyaltyPoints.LoyaltyStatics?.tierToken
  );

  useEffect(() => {
    const getDeliveryInfo = async () => {
      try {
        const stateId = isUserLoggedIn
          ? null
          : LocalStorageService.get(EXPRESS_DELIVERY_STATE_ID_KEY);

        const response = await deliveryInfoService.getDeliveryInfo({
          ...(stateId && { guest_state_id: stateId })
        });
        setDeliveryInfo(response);
      } catch (error) {
        console.error("Delivery info fetch got error:", error);
      }
    };
    getDeliveryInfo();
  }, [loyaltyTier, isUserLoggedIn]);

  return deliveryInfo as DeliveryInfo[];
};

export default useDeliveryOptionsInfo;
